module.exports = __webpack_public_path__ + "media/images/signatures/2024/bettina-0afe8e2b6a9f8e2b5a741bbd3fedd294.png";